var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustbinBorder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "#E77B7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 9.48437C24.2525 9.23687 21.74 9.10938 19.235 9.10938C17.75 9.10938 16.265 9.18438 14.78 9.33438L13.25 9.48437",
    stroke: "#E77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 8.71969L17.54 7.73719C17.66 7.02469 17.75 6.49219 19.0175 6.49219H20.9825C22.25 6.49219 22.3475 7.05469 22.46 7.74469L22.625 8.71969",
    stroke: "#E77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1344 11.8516L24.6469 19.4041C24.5644 20.5816 24.4969 21.4966 22.4044 21.4966H17.5894C15.4969 21.4966 15.4294 20.5816 15.3469 19.4041L14.8594 11.8516",
    stroke: "#E77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 17.375H21.2475",
    stroke: "#E77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 14.3672H21.875",
    stroke: "#E77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbinBorder);
export default __webpack_public_path__ + "static/media/DustbinBorder.f18bd2beffcfd1e28f894394ade92475.svg";
export { ForwardRef as ReactComponent };